import { IFormState, InitialFormState } from "./forms";

export interface Entrada {
  id_entrada: string;
  id_categorizacion: string; // Assuming this type, adjust as per actual structure
  id_tema: string;
  indice: number | null; // Index can be null based on your JSON
  nombreEntrada: string;
  nombre_empresa: string;
  banConSeguimiento: number;
  banEsActivo: number;
  remitente_descripcion: string;
  fecha_inicio: string;
  nombreEntradaCompleto: string;
  archivos: Archivo[];
  entregables: Entregable[];
  justificacionSeguimiento?: string;
  id_empresa?: string;
  desc_empresa?: string;
  remitenteCompleto?: string;
  idSobre?: string;
  documentoSoporte?: string;
}

export interface Archivo {
  id_entrada: string;
  indice: number;
  nombre_archivo: string;
  metadata: string;
  banEsActivo: number;
  ts_alta_audit: string;
  ts_actualiza_audit: string;
  usuario_audit: any;
  indiceEnTema: number;
}

export interface Entregable {
  id_entregable: string;
  id_entrada: string;
  id_edo_entregable: number;
  nombreEntregable: string;
  urlEntregable: string;
  indice: number;
  id_tema?: string;
  selected?: boolean;
}

export interface VoBo {
  id_tema: string;
  id_edo_tema: number;
  nombreTema: string;
  descripcionTema: string;
  id_tipo_despacho: number;
  indice: number | null;
  descripcion: string;
  id_empresa: string;
  banEsImpreso: number;
  ts_alta_audit: string;
  nombre_empresa: string;
  entradas: Entrada[];
  marcarParaImpresion?: boolean;
}

export interface Informativo {
  id_tema: string;
  id_edo_tema: number;
  nombreTema: string;
  descripcionTema: string;
  id_tipo_despacho: number;
  indice: number | null;
  descripcion: string;
  id_empresa: string;
  banEsImpreso: number;
  ts_alta_audit: string;
  nombre_empresa: string;
  entradas: Entrada[];
  marcarParaImpresion?: boolean;
}

export interface Empresa {
  nombre_empresa: string;
  id_empresa: string;
  isOtro: boolean;
  counter: number;
  counterInfo: number;
  counterVoBo: number;
  VoBo: VoBo[];
  Informativo: Informativo[];
}

export interface IResDespacho {
  [key: string]: Empresa;
}

export interface IDespacho {
  nombre_empresa: string;
  id_empresa: string;
  isOtro: boolean;
  counter: number;
  counterInfo: number;
  counterVoBo: number;
  VoBo: VoBo[] | Informativo[];
  Informativo: Informativo[] | VoBo[];
  expanded?: boolean;
  marcarParaImpresion: boolean;
}

export interface IInfoVoboDespacho {
  nombre_empresa: string;
  id_empresa: string;
  isOtro: boolean;
  counter: number;
  counterInfoVobo: number;
  temas: VoBo[] | Informativo[];
  title: string;
  expanded?: boolean;
}

export interface IFormaEnvio {
  despachos: IDespacho[];
  error: boolean;
  despacho: IDespacho;
  entradas: Entrada[];
  form: IFormState;
  nuevoDespacho: boolean;
  contador: IContador;
  guardando: boolean;
  currentExpanded: string; //informativo/vobo/''
  status: string;
}
export const despachoInit: IDespacho = {
  nombre_empresa: "",
  id_empresa: "",
  isOtro: false,
  counter: 0,
  counterInfo: 0,
  counterVoBo: 0,
  VoBo: [],
  Informativo: [],
  expanded: false,
  marcarParaImpresion: false,
};

export const initDespachos: IFormaEnvio = {
  despachos: [],
  error: false,
  despacho: despachoInit,
  entradas: [],
  form: InitialFormState,
  nuevoDespacho: false,
  contador: {
    acuerdo: "",
    despacho: "",
  },
  guardando: false,
  currentExpanded: "",
  status: "",
};

export interface IPorSeleccion {
  toPrint: ToPrint[];
}

export interface ToPrint {
  nombre_empresa: string;
  nombreTema: string;
  tipo_despacho: string;
}

export interface IInfoVobo {
  id_tipo_despacho: number;
  type: string;
}

export interface RImprimirEmpresa {
  id: string;
  descripcion: string;
  id_empresa: string;
}
export interface ITemaEliminado {
  nombreUsuario: string;
  nombreTema: string;
  descripcionTema: string;
  justificacion: string;
  id_empresa: string;
  notificacion: string;
}

export interface ITemaMrbEliminado {
  descripcionTema: string;
  id_categorizacion: string;
  justificacion: string;
  nombreTema: string;
  nombreUsuario: string;
  notificacion: string;
}

export interface IQuitarTema {
  id_tema: string;
  justificacion: string;
  id_tipo_forma: number;
  id_usuario: string;
  usuario: string;
}

export interface ICancelarEntregable {
  id_tema: string;
  justificacion: string;
  entregables: Entregable[];
  id_usuario: string;
  usuario: string;
}

export interface IEntradaLista {
  id_entrada: string;
  id_categorizacion: string;
  id_tema: string;
  indice: number;
  nombreEntrada: string;
  banConSeguimiento: number;
  justificacionSeguimiento: string;
  banEsActivo: number;
  id_empresa: string;
  desc_empresa: string;
  id_tipo_forma: number;
  selected?: boolean;
}

export interface ITerminarSeguimiento {
  id_tema: string;
  justificacion: string;
  entradas: IEntradaLista[];
  id_usuario: string;
  usuario: string;
}

export interface ITerminarEntregable {
  id_tema: string;
  entregables: Entregable[];
  id_usuario: string;
  usuario: string;
}

////
export interface INuevoTemaDespacho {
  nombreTema: string;
  id_empresa: string;
  id_tipo_despacho: number;
  nombre_empresa: string;
  entradas: IEntradaDespacho[];
}

export interface IEntradaDespacho {
  id_entrada: string;
  id_categorizacion: string;
  id_tema: string | null;
  indice: string | null;
  nombreEntrada: string;
  nombreEntradaCompleto: string;
  banConSeguimiento: number;
  justificacionSeguimiento: string;
  banEsActivo: number;
  id_empresa: string;
  desc_empresa: string;
  fecha_inicio: string;
  remitente_descripcion: string;
  remitenteCompleto: string;
  idSobre: string;
  documentoSoporte: string;
  nombre_empresa?: string;
  value: string;
  entregables: any[];
  archivos: any[];
  esFront?: boolean;
  puedeVer?: boolean;
  nuevaEntrada?:boolean;
}

export interface IContador {
  acuerdo: string;
  despacho: string;
}
